import { Component, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-approve-actions-modal',
    templateUrl: './approve-actions-modal.component.html',
    styleUrl: './approve-actions-modal.component.scss',
})
export class ApproveActionsModalComponent {
    @Output() saveActions = new EventEmitter<any>();
    data: any;
    approveForm: UntypedFormGroup;
    displayData: any;
    actionType: number;

    constructor(
        private ngbActiveModal: NgbActiveModal,
        private formBuilder: UntypedFormBuilder
    ) {}

    ngOnInit() {
        this.approveForm = this.formBuilder.group({
            comments: ['', [Validators.maxLength(500)]],
        });

        // Apply validation based on actionType
        this.setCommentsValidation();
    }

    setCommentsValidation() {
        const commentsControl = this.approveForm.get('comments');

        if (this.actionType === 1 || this.actionType === 2) {
            commentsControl.setValidators([Validators.required, Validators.maxLength(500)]);
        } else {
            commentsControl.setValidators([Validators.maxLength(500)]);
        }

        commentsControl.updateValueAndValidity();
    }

    closeModal() {
        this.ngbActiveModal.close(false);
    }

    Submit() {
        if (this.approveForm.valid) {
            let payLoad = {
                ApprovalId: this.data.approvalId,
                State: this.actionType == 1 ? 2 : this.actionType == 2 ? 4 : 2,
                Comments: this.approveForm.get('comments').value,
                actionType: this.actionType,
                itemType: this.data.item.value,
            };
            this.saveActions.emit(payLoad);
            // your save logic
        }
    }
}
